/**
 * Parses a cell input of the demand matrix (orders / forecasts / intermediate products).
 *
 * Return value:
 *  - `null`  -> clear the cell (no record): on an empty string, an invalid number or a negative value
 *  - number  -> the entered quantity (>= 0)
 *
 * `decimals: true` allows decimal numbers (intermediate products), otherwise only integers (orders/forecasts).
 */
export function parseDemandCellInput(raw: string, opts?: { decimals?: boolean }): number | null {
  const trimmed = raw.trim();
  if (trimmed === '') return null;
  // The UI is German: users type "2,5" for 2.5. parseFloat/parseInt only understand a dot,
  // so a raw comma would be truncated ("2,5" -> 2). Normalize German notation first: when a
  // comma is present, treat it as the decimal separator and dots as thousands separators.
  const normalized = trimmed.includes(',')
    ? trimmed.replace(/\./g, '').replace(',', '.')
    : trimmed;
  const v = opts?.decimals ? parseFloat(normalized) : parseInt(normalized, 10);
  if (Number.isNaN(v) || v < 0) return null;
  return v;
}
